import NextLink from '@/components/NextLink';
import { useAuthenticationModalStore } from '@/core/stores/auth';
import { useUserStore } from '@/core/stores/user';
import { generateAvatar } from '@/utils/generateAvatar';
import Image from 'next/image';
import React, { useEffect } from "react";
import { Wallet2, UserCircle, Logout3, Heart, Settings, CalendarMinimalistic, Gift } from "solar-icon-set";
import cookies from 'js-cookie'
import useNextRouter from '@/hooks/useNextRouter';
import { useFormStore } from '@/core/stores/influencerForm';
import useAppStore from '@/core/stores/app';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/pro-regular-svg-icons';
import ModalInMobile from '@/components/ui/ModalInMobile';
import WalletIcon from '@/components/icons/WalletIcon';
import MyTripIcon from '@/components/icons/MyTripIcon';
import FavoriteItemsIcon from '@/components/icons/FavoriteItemsIcon';
import BookingIcon from '@/components/icons/BookingIcon';
import ReferAndEarnIcon from '@/components/icons/ReferAndEarnIcon';
import SettingsIcon from '@/components/icons/SettingsIcon';
import ImageLoading from '@/components/ImageLoading';

type SidebarProps = {
    show: boolean;
    setShow: (show: boolean) => void;
};

const Sidebar: React.FC<SidebarProps> = ({ show, setShow }) => {
    useEffect(() => {
        if (show) {
            const scrollY = window.scrollY;
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = "100%";
            return () => {
                document.body.style.position = "";
                document.body.style.top = "";
                document.body.style.width = "";
                window.scrollTo(0, scrollY);
            };
        }
    }, [show]);

    const { _id, firstName, lastName, displayName, walletBalance, email, image } = useUserStore()
    const { setShowAuthModal } = useAuthenticationModalStore()
    const cookie = cookies
    const router = useNextRouter()
    const { resetUserProfile } = useUserStore()
    const { restForm } = useFormStore();
    const { isApp } = useAppStore()
    const handleLogOut = () => {
        cookie.remove('ut');
        cookie.remove('ct');
        localStorage.clear();
        resetUserProfile()
        restForm()
        router.push('/')
        router.refresh()
    }
    return !isApp ? (
        <>
            {show && <div className="fixed inset-0 bg-black bg-opacity-50 z-40"
                onTouchStart={() => setShow(false)}
                onClick={() => setShow(false)}></div>}
            {<div
                className={`fixed top-0 left-0 h-full bg-white shadow-lg transform
                     ${show ? "translate-x-0" : isApp ? '' : "-translate-x-full"
                    } transition-transform duration-300 ease-in-out z-[100]`}
            >
                <div className="p-4 w-full flex flex-col  gap-4 relative">

                    {/* Profile Section */}
                    <div className="flex max-w-full w-full  items-center relative
                     gap-3 border-b pb-4">

                        {_id ?
                            <div className="relative">
                                <NextLink href={'/profile'}
                                    className=" z-50 flex flex-row gap-2 items-center">
                                    <span className='size-8 rounded-full'>
                                        {(email || image) && <ImageLoading width={100} height={100} src={image || generateAvatar(email)}
                                            className="object-cover w-full h-full rounded-full " alt="Planingo" />}
                                    </span>
                                </NextLink>

                            </div> :
                            <button onClick={() => setShowAuthModal(true)}
                                className="text-secondary-500 flex items-center "
                                aria-label="open-authentication-modal"

                            >
                                <UserCircle size={24} />
                            </button>
                        }
                        {_id ? <div>
                            <p className="font-semibold">{displayName}</p>
                            <p className="text-sm text-gray-500">View My Profile</p>
                        </div> : <div >
                            <button onClick={() => setShowAuthModal(true)}>Log in</button>
                        </div>}
                        <span className='grow'></span>

                    </div>
                    {/* Wallet */}
                    {!!_id && <div className="flex items-center gap-3 bg-gray-100 p-3 rounded-lg">
                        <Wallet2 className="text-2xl text-blue-600" />
                        <span className="text-lg font-semibold">${walletBalance}</span>
                    </div>}
                    {/* Menu Items */}
                    <nav className="flex flex-col min-w-56 gap-2">
                        <SidebarItem href='#' icon={WalletIcon} text="$ --" />
                        <SidebarItem href='/profile/my-trips' icon={MyTripIcon} text="My Trip" />
                        <SidebarItem href='/profile/saved/hotels' icon={FavoriteItemsIcon} text="Favorite Items" />
                        <SidebarItem href='/profile/orders' icon={BookingIcon} text="Booking" />
                        <SidebarItem href='/profile' icon={ReferAndEarnIcon} text="Refer & Earn" />
                        <SidebarItem href='#' icon={SettingsIcon} text="Settings" />
                        {/* <SidebarItem icon={Settings} text="Settings" /> */}
                    </nav>
                    {/* Logout */}
                    {_id && <button onClick={handleLogOut} className="flex text-xs items-center gap-3 text-gray-600 ">
                        <Logout3 /> Log out
                    </button>}
                </div>
            </div>}
        </>
    ) : <ModalInMobile show={show} onClose={() => setShow(false)}>
        <div className="p-4 w-full h-[350px] flex flex-col  gap-4 relative pb-8">

            {/* Profile Section */}
            <div className="flex max-w-full w-full  items-center relative
 gap-3 border-b pb-4">

                {_id ?
                    <div className="relative">
                        <NextLink href={'/profile'}
                            className=" z-50 flex flex-row gap-2 items-center">
                            <span className='size-8 rounded-full'>
                                {(email || image) && <ImageLoading width={100} height={100} src={image || generateAvatar(email)}
                                    className="object-cover w-full h-full rounded-full " alt="Planingo" />}
                            </span>
                        </NextLink>

                    </div> :
                    <button onClick={() => setShowAuthModal(true)}
                        className="text-secondary-500 flex items-center "
                        aria-label="open-authentication-modal"
                    >
                        <UserCircle size={24} />
                    </button>
                }
                {_id ? <div>
                    <p className="font-semibold">{displayName}</p>
                    <p className="text-sm text-gray-500">View My Profile</p>
                </div> : <div >
                    <button onClick={() => setShowAuthModal(true)}>Log in</button>
                </div>}


            </div>
            {/* Wallet */}
            {!!_id && <div className="flex items-center gap-3 bg-gray-100 p-3 rounded-lg">
                <Wallet2 className="text-2xl text-blue-600" />
                <span className="text-lg font-semibold">${walletBalance}</span>
            </div>}
            {/* Menu Items */}
            <nav className="flex flex-col gap-2">
                {/* <SidebarItem href='#' icon={WalletIcon} text="$ --" /> */}
                <SidebarItem href='/profile/my-trips' icon={MyTripIcon} text="My Trip" />
                <SidebarItem href='/profile/saved/hotels' icon={FavoriteItemsIcon} text="Favorite Items" />
                <SidebarItem href='/profile/orders' icon={BookingIcon} text="Booking" />
                <SidebarItem href='/profile' icon={ReferAndEarnIcon} text="Refer & Earn" />
                <SidebarItem href='#' icon={SettingsIcon} text="Settings" />
                {/* <SidebarItem icon={Settings} text="Settings" /> */}
            </nav>
            {/* Logout */}
            {_id && <button onClick={handleLogOut} className="flex text-xs items-center gap-3 text-gray-600 ">
                <Logout3 /> Log out
            </button>}
        </div>
    </ModalInMobile>;
};

type SidebarItemProps = {
    icon: React.ElementType;
    text: string;
    href: string
};

const SidebarItem: React.FC<SidebarItemProps> = ({ icon: Icon, text, href }) => (
    <NextLink href={href} className="flex text-sm items-center gap-3 p-3 border rounded-2xl cursor-pointer hover:bg-gray-100 border-secondary-500">
        <Icon className=" text-secondary-500" />
        <span >{text}</span>
    </NextLink>
);

export default Sidebar;
